import React from 'react'
import {Page, Splitter, SplitterContent, ActionSheet, ActionSheetButton, Row, Col} from 'react-onsenui'
import Loader from 'react-loader-spinner';
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom';
import {NaverMap, Marker, Polyline} from 'react-naver-maps';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import ReactTimeAgo from 'react-time-ago';

import {showAlertMessage} from "../../modules/alert";
import {showToastMessage} from "../../modules/toast";
import {showLoaderMessage, hideLoaderMessage} from "../../modules/loader";
import SideMenu from "../app/sideMenu";
import {CHECK_ANONYMOUS, NAVER_THUMBNAIL_GETTER, SVG_MARKER_ICON, DISTRICT_CODE, GET_HEIGHT_FOR_NAVER_MAP, SCHEDULE_SORT_KEY_TO_NAME} from "../../modules/variable/common_variable";
import UserInfoDialog from '../user/userInfoDialog';
import TargetScheduleActionSheetFunctions from '../schedule/module/targetScheduleActionSheetFunctions';
import _ from "underscore";
import TargetScheduleActionSheetDescription from "./module/targetScheduleActionSheetDescription";
import {useCurrentLocation} from "../../modules/native";

class ListSchedule extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        //firebase.functions().useFunctionsEmulator('http://localhost:5000');
        this.scheduleRef = firebase.firestore().collection('user_schedule');
        //this.scheduleSupplementRef = firebase.firestore().collection('user_schedule_supplement');

        this.state = {
            openSideMenu: false,
            scheduleList: {isLoading: false, list: [], lastVisible: null, order: {type: 'date', direction: 'desc'}, listTitle: '', showMore: false},
            searchScheduleText: this.props.location.state && this.props.location.state.parameter && this.props.location.state.parameter.placeName ? this.props.location.state.parameter.placeName : '',
            searchSort: {all: true, date: false, picnic: false, sightseeing: false, shopping: false, eating: false, history: false, study: false, healing: false, activity: false, sport: false, outside: false, inside: false},
            changeListOrderActionSheet: {open: false},
            routerParam: this.props.location.state,
            localParam: {code: 0, parentCode: 0},
            getListLimit: 20,

            targetScheduleActionSheet: {open: false, title: '', data: null, polyLine: [], mapCenter: {lat: 37.554690, lng: 126.970702}, targetToMapCenter: null, targetNaverPlaceActionSheet: null, tab: 'schedule'},
            targetScheduleSupplement: {comments: [], commentsOpen: false, commentText: '', commentOnFocus: false},
            targetNaverPlaceActionSheet: {targetMarker: null, open: false, isLoading: false, data: null},
            userInfoDialog: {open: false, uid: ''},
            trafficConditionActionSheet: {open: false, list: []},
            listTypeToName: {MINE: '내가 만든', USER: '', SHARE: '공유된', LOCAL: '지역', LOCAL_PARENT: '지역', RECOMMEND: '추천', INCLUDE: '포함'}
        };
    }

    naverMaps = window.naver.maps;

    componentDidMount(){
        if(this.props.userInfo.isSignedIn){
            this.getScheduleList(this.props.userInfo, this.props.location.state, true, null, null);
        }

        if(this.props.location.state && this.props.location.state.type === 'SHARE' && this.props.location.state.parameter && this.props.location.state.parameter.code){
            this.setState({localParam: {code: this.props.location.state.parameter.code, parentCode: _.findWhere(DISTRICT_CODE, {code: this.props.location.state.parameter.code}).parentCode}});
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.userInfo.isSignedIn && nextProps.userInfo.isSignedIn){
            this.getScheduleList(nextProps.userInfo, nextProps.location.state, true, null, null);
        }else if(this.props.location.state.type !== nextProps.location.state.type){
            this.getScheduleList(nextProps.userInfo, nextProps.location.state, true, null, null);
        }

        if(this.props.usedCurrentLocation === true && nextProps.usedCurrentLocation === false){
            this.setTargetToMapCenter(null, nextProps.currentLocation);
            this.props.useCurrentLocation();
        }
    }

    getScheduleList = (userInfo, routerParam, first, order, sort) => {
        const limit = this.state.getListLimit;
        this.setState({routerParam: routerParam});
        //console.log(routerParam);

        let query;
        if(first){
            let listTitle = routerParam.type !== 'USER' ? this.state.listTypeToName[routerParam.type] : routerParam.parameter.nickname;
            const defaultOrder =  routerParam.type !== 'RECOMMEND' ? {type: "date", direction: "desc"} : {type: "recommend", direction: "desc"};
            if(!order){
                order = defaultOrder;
            }
            this.setState({scheduleList: {...this.state.scheduleList, isLoading: true, lastVisible: null, list: [], listTitle: listTitle, order: order}});
        }else{
            this.setState({scheduleList: {...this.state.scheduleList, isLoading: true}});
            order = this.state.scheduleList.order;
        }

        if(routerParam){
            switch (routerParam.type){
                case 'MINE':
                    query = this.scheduleRef.where("uid", "==", userInfo.uid);
                    query = query.where("use", "==", true);
                    query = query.orderBy(order.type, order.direction);
                    if(!first){
                        query = query.startAfter(this.state.scheduleList.lastVisible);
                    }
                    query = query.limit(limit);
                    break;
                case 'USER':
                    query = this.scheduleRef.where("uid", "==", routerParam.parameter.uid);
                    query = query.where("use", "==", true);
                    query = query.where("share", "==", true);
                    query = query.orderBy(order.type, order.direction);
                    if(!first){
                        query = query.startAfter(this.state.scheduleList.lastVisible);
                    }
                    query = query.limit(limit);
                    break;
                case 'SHARE':
                    query = this.scheduleRef.where("use", "==", true);
                    query = query.where("share", "==", true);

                    let searchScheduleText = this.state.searchScheduleText;
                    if(this.state.searchScheduleText !== ''){
                        searchScheduleText = searchScheduleText.replace("#", "");
                        /*searchScheduleText = searchScheduleText.trim();*/
                        if(searchScheduleText !== ''){
                            query = query.where("searchTags", "array-contains", searchScheduleText);
                        }
                    }

                    let localCode = routerParam.parameter && routerParam.parameter.code ? routerParam.parameter.code : null;
                    if(localCode){
                        query = query.where("representative.district.code", "==", routerParam.parameter.code)
                    }else{
                        let parentCode = routerParam.parameter && routerParam.parameter.parentCode ? routerParam.parameter.parentCode : null;
                        if(!parentCode){
                            parentCode = 0;
                            this.setState({routerParam: {...this.state.routerParam, type: 'SHARE', parameter: {...this.state.routerParam.parameter, parentCode: parentCode}}});
                        }else{
                            query = query.where("representative.parent.parentCode", "==", parentCode);
                        }
                    }

                    if(sort === null){
                        let searchSort = this.state.searchSort;
                        for (let key in searchSort) {
                            if (searchSort.hasOwnProperty(key) && searchSort[key] === true) {
                                sort = key;
                            }
                        }
                    }
                    if(sort !== 'all'){
                        query = query.where("sort." + sort, "==", true);
                    }

                    query = query.orderBy(order.type, order.direction);
                    if(!first){
                        query = query.startAfter(this.state.scheduleList.lastVisible);
                    }
                    query = query.limit(limit);
                    break;
                default:
                    query = this.scheduleRef.where("use", "==", true);
                    query = query.where("share", "==", true);
                    query = query.orderBy(order.type, order.direction);
                    if(!first){
                        query = query.startAfter(this.state.scheduleList.lastVisible);
                    }
                    query = query.limit(limit);
            }
        }else{
            query = this.scheduleRef.where("use", "==", true);
            query = query.where("share", "==", true);
            query = query.orderBy(order.type, order.direction);
            if(!first){
                query = query.startAfter(this.state.scheduleList.lastVisible);
            }
            query = query.limit(limit);
        }


        /*if(first){
            let listTitle = routerParam.type !== 'USER' ? this.state.listTypeToName[routerParam.type] : routerParam.parameter.nickname;
            const defaultOrder =  routerParam.type !== 'RECOMMEND' ? {type: "date", direction: "desc"} : {type: "recommend", direction: "desc"};
            if(!order){
                order = defaultOrder;
            }
            this.setState({scheduleList: {...this.state.scheduleList, isLoading: true, lastVisible: null, list: [], listTitle: listTitle, order: order}});

            if(routerParam){
                switch (routerParam.type){
                    case 'MINE':
                        query = this.scheduleRef.where("uid", "==", userInfo.uid);
                        query = query.where("use", "==", true);
                        query = query.orderBy(order.type, order.direction)
                        query = query.limit(limit);
                        break;
                    case 'USER':
                        query = this.scheduleRef.where("uid", "==", routerParam.parameter.uid);
                        query = query.where("use", "==", true);
                        query = query.where("share", "==", true);
                        query = query.orderBy(order.type, order.direction);
                        query = query.limit(limit);
                        break;
                    case 'SHARE':
                        query = this.scheduleRef.where("use", "==", true);
                        query = query.where("share", "==", true);

                        if(this.state.searchScheduleText !== ''){
                            query = query.where("searchTags", "array-contains", this.state.searchScheduleText);
                        }

                        let localCode = routerParam.parameter && routerParam.parameter.code ? routerParam.parameter.code : null;
                        if(localCode){
                            query = query.where("representative.district.code", "==", routerParam.parameter.code)
                        }else{
                            let parentCode = routerParam.parameter && routerParam.parameter.parentCode ? routerParam.parameter.parentCode : null;
                            if(!parentCode){
                                parentCode = 0;
                                this.setState({routerParam: {...this.state.routerParam, type: 'SHARE', parameter: {...this.state.routerParam.parameter, parentCode: parentCode}}});
                            }else{
                                query = query.where("representative.parent.parentCode", "==", parentCode);
                            }
                        }

                        query = query.orderBy(order.type, order.direction);
                        query = query.limit(limit);
                        break;
                    case 'LOCAL':
                        query = this.scheduleRef.where("representative.district.code", "==", routerParam.parameter.code).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
                        break;
                    case 'LOCAL_PARENT':
                        let parentCode = routerParam.parameter && routerParam.parameter.parentCode ? routerParam.parameter.parentCode : null;
                        if(!parentCode){
                            parentCode = 11;
                            this.setState({routerParam: {...this.state.routerParam, type: 'LOCAL_PARENT', parameter: {...this.state.routerParam.parameter, parentCode: parentCode}}});
                        }
                        query = this.scheduleRef.where("representative.parent.parentCode", "==", parentCode).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
                        break;
                    case 'RECOMMEND':
                        query = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
                        break;
                    case 'INCLUDE':
                        query = this.scheduleRef.where("scheduleOrder", "array-contains", routerParam.parameter.placeId).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
                        break;
                    default:
                        query = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
                }
            }else{
                query = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).limit(limit);
            }
        }else{
            this.setState({scheduleList: {...this.state.scheduleList, isLoading: true}});
            const order = this.state.scheduleList.order;

            switch (routerParam.type){
                case 'MINE':
                    query = this.scheduleRef.where("uid", "==", userInfo.uid).where("use", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                case 'USER':
                    query = this.scheduleRef.where("uid", "==", routerParam.parameter.uid).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                case 'SHARE':
                    query = this.scheduleRef.where("use", "==", true);
                    query = query.where("share", "==", true);

                    if(this.state.searchScheduleText !== ''){
                        query = query.where("searchTags", "array-contains",this.state.searchScheduleText);
                    }

                    query = query.orderBy(order.type, order.direction);
                    query = query.startAfter(this.state.lastVisible);
                    query = query.limit(limit);
                    break;
                case 'LOCAL':
                    query = this.scheduleRef.where("representative.district.code", "==", routerParam.parameter.code).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                case 'LOCAL_PARENT':
                    query = this.scheduleRef.where("representative.parent.parentCode", "==", routerParam.parameter.parentCode).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                case 'RECOMMEND':
                    query = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                case 'INCLUDE':
                    query = this.scheduleRef.where("scheduleOrder", "array-contains", routerParam.parameter.placeId).where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
                    break;
                default:
                    query = this.scheduleRef.where("use", "==", true).where("share", "==", true).orderBy(order.type, order.direction).startAfter(this.state.scheduleList.lastVisible).limit(limit);
            }
        }*/

        query.get().then((snapshot) => {
            // Get the last visible document
            const lastVisible = snapshot.docs[snapshot.docs.length-1];
            //console.log(lastVisible);

            let qd = [];
            snapshot.forEach((doc) => {
                if(doc.exists){
                    let d = doc.data();
                    d['DOC_ID'] = doc.id;
                    qd.push(d);
                }
            });
            let showMore = true;
            if(qd.length < limit){
                showMore = false;
            }

            if(first){
                this.setState({scheduleList: {...this.state.scheduleList, isLoading: false, lastVisible: lastVisible, list: qd, showMore: showMore}});
            }else{
                this.setState({scheduleList: {...this.state.scheduleList, isLoading: false, lastVisible: lastVisible, list: this.state.scheduleList.list.concat(qd), showMore: showMore}});
            }
        });
    };

    showSideMenu = (show) => {
        this.setState({openSideMenu: show});
    };

    showTargetSchedule = (target) => {
        /*console.log(target);
        target.id = target.DOC_ID;
        firebase.firestore().collection('staff_schedule').doc(target.id).set(target);*/

        //console.log(target);
        let naverMapPolyLineList = [];
        target.scheduleOrder.map((e) => {
            const so = target.schedule[e];
            naverMapPolyLineList.push(new this.naverMaps.LatLng(so.y, so.x));
        });
        const firstSchedule = target.schedule[target.scheduleOrder[0]];
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: true, title: target.title, data: target, polyLine: naverMapPolyLineList, mapCenter:{lat: firstSchedule.y, lng: firstSchedule.x}}});
    };

    setTargetToMapCenter = (event, target) => {
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }

        const mapCenter = {y: target.y, x: target.x, lat: target.y, lng: target.x};
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, mapCenter: mapCenter, targetToMapCenter: mapCenter}});
        setTimeout(() => {
            this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetToMapCenter: null}});
        }, 2000)
    };

    goToCreateSchedule = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        this.props.history.push("/createSchedule");
    };

    showUserInfoDialog = (event, uid) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({userInfoDialog: {...this.state.userInfoDialog, open: true, uid: uid}});
    };

    changeOrderType = (type, direction) => {
        this.setState({scheduleList: {...this.state.scheduleList, order: {type: type, direction: direction}}, changeListOrderActionSheet: {...this.state.changeListOrderActionSheet, open: false}});
        this.getScheduleList(this.props.userInfo, this.state.routerParam, true, {type: type, direction: direction}, null);
    };

    getOrderSelectorButton = () => {
        const order = this.state.scheduleList.order;
        let text, arrow;
        if(order.type === 'date'){
            text = '날짜';
        }else{
            text = '추천'
        }
        if(order.direction === 'desc'){
            arrow = '↓';
        }else{
            arrow = '↑'
        }

        return (
            <button className="button button--material--flat" onClick={() => this.setState({changeListOrderActionSheet: {...this.state.changeListOrderActionSheet, open: true}})}><span>정렬: </span>{[text, arrow].join(' ')}</button>
        )
    };

    getLocalSelector = () => {
        if(this.state.localParam.parentCode === 0){
            return (
                <select className="select-input select-input--material" value={0} onChange={(event) => this.changeLocalParam(event, 'LOCAL')}>
                    <option value={0}>전체</option>
                </select>
            )
        }

        const localDistrictCode = _.where(DISTRICT_CODE, {parentCode: this.state.localParam.parentCode});

        let localOptions = [];
        localOptions.push(<option key={['local','code',0].join('-')} value={0}>전체</option>);
        for(let i = 0; i < localDistrictCode.length; i ++){
            localOptions.push(<option key={['local','code',localDistrictCode[i].code].join('-')} value={localDistrictCode[i].code}>{localDistrictCode[i].name}</option>);
        }

        return (
            <select className="select-input select-input--material" value={this.state.localParam.code} onChange={(event) => this.changeLocalParam(event, 'LOCAL')}>
                {localOptions}
            </select>
        )
    };

    changeLocalParam = (event, type) => {
        const value = Number(event.target.value);

        if(type === 'PARENT'){
            this.setState({localParam: {code: 0, parentCode: value}});
            this.getScheduleList(this.props.userInfo, {type: 'SHARE', parameter: {parentCode: value}}, true, this.state.scheduleList.order, null);
        }else if(type === 'LOCAL'){
            if(value !== 0){
                this.setState({localParam: {code: value, parentCode: this.state.localParam.parentCode}});
                this.getScheduleList(this.props.userInfo, {type: 'SHARE', parameter: {code: value}}, true, this.state.scheduleList.order, null)
            }else{
                this.setState({localParam: {code: 0, parentCode: this.state.localParam.parentCode}});
                this.getScheduleList(this.props.userInfo, {type: 'SHARE', parameter: {parentCode: this.state.localParam.parentCode}}, true, this.state.scheduleList.order, null)
            }
        }
    };

    chooseLocal = (code) => {
        this.setState({localParam: {code: code, parentCode: _.findWhere(DISTRICT_CODE, {code: code}).parentCode}});
        this.getScheduleList(this.props.userInfo, {type: 'SHARE', parameter: {code: code}}, true, this.state.scheduleList.order, null)
    };

    goToEditSchedule = (data) => {
        this.props.history.push({
            pathname: '/editSchedule',
            state: {data: data}
        });
    };

    deleteSchedule = (DOC_ID) => {
        if (window.confirm("내 일정을 삭제하시겠습니까?") === true){
            this.props.showLoaderMessage("일정을 삭제중입니다.");

            firebase.auth().currentUser.getIdToken(true).then((token) => {
                const deleteSchedule = firebase.functions().httpsCallable('deleteSchedule');

                deleteSchedule({token: token, DOC_ID: DOC_ID, uid: this.props.userInfo.uid}).then((result) => {
                    this.props.hideLoaderMessage();
                    if (result.data.result === 'success') {
                        this.props.showToastMessage('일정 삭제에 성공하였습니다.');

                        let list = this.state.scheduleList.list;
                        const docIndex = _.findIndex(list, {DOC_ID: DOC_ID});
                        list.splice(docIndex, 1);
                        this.setState({scheduleList: {...this.state.scheduleList, list: list}});
                    } else {
                        console.error(result.data.message);
                        this.props.showToastMessage('일정 삭제 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
                    }
                });
            }).catch((err) => {
                this.props.hideLoaderMessage();
                console.error(err);
                this.props.showToastMessage('일정 삭제 과정에서 문제가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.');
            });
        }
    };

    showNaverPlaceInFunctions = (marker) => {
        //console.log(marker);
        this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetNaverPlaceActionSheet: {targetMarker: marker, open: true, isLoading: false, data: null}}});
    };

    searchScheduleByTagName = (event) => {
        event.preventDefault();

        let routerParam = this.state.routerParam;
        if(routerParam && routerParam.parameter){
            routerParam = {type: 'SHARE', parameter: routerParam.parameter};
        }else{
            routerParam = {type: 'SHARE'};
        }

        this.getScheduleList(this.props.userInfo, routerParam, true, this.state.scheduleList.order, null)
    };

    fillInForm = (type, event) => {
        switch (type){
            case 'searchScheduleText':
                if(event.target.value.length <= 20) {
                    this.setState({searchScheduleText: event.target.value});
                }else{
                    this.props.showToastMessage('20자 내로 검색해주시기 바립니다.');
                }
                break;
            default:
                console.error('NO TARGET');
        }
    };

    requestCurrentLocation = () => {
        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_CURRENT_LOCATION'});
            window.postMessage(message, "*");
        }else{
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const gpsLocation = {y: position.coords.latitude, x: position.coords.longitude, lat: position.coords.latitude, lng: position.coords.longitude};
                    this.setTargetToMapCenter(null, gpsLocation);
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));
                }, (error) => {
                    console.error(error);
                    this.props.showToastMessage('위치 정보를 확인하는 과정에서 오류가 발생하였습니다.');
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                this.props.showToastMessage('본 기기가 GPS를 지원하지 않습니다.');
            }
        }
    };

    useSortOfSchedule = (type) => {
        let sort = this.state.searchSort;
        for (let key in sort) {
            if (sort.hasOwnProperty(key)) {
                sort[key] = false;
            }
        }
        sort[type] = true;

        this.setState({searchSort: sort});
        this.getScheduleList(this.props.userInfo, this.state.routerParam, true, this.state.scheduleList.order, type);
    };

    render() {
        const TSAS = this.state.targetScheduleActionSheet;
        const SL = this.state.scheduleList.list;

        return (
            <Splitter>
                <SideMenu openSideMenu={this.state.openSideMenu} showSideMenu={this.showSideMenu}/>
                <SplitterContent>
                    <Page contentStyle={{overflowY: 'scroll'}}>
                        <div className="toolbar toolbar--transparent">
                            <div className="toolbar__left">
                                <span className="toolbar-button" onClick={() => this.props.history.goBack()}>
                                    <i className="ion-ios-arrow-left"/>
                                </span>
                                <span className="toolbar-button" onClick={() => this.props.history.push('/home')}>
                                    <i className="ion-ios-home"/>
                                </span>
                            </div>
                            <div className="toolbar__center">
                                {this.state.scheduleList.listTitle} 일정
                            </div>
                            <div className="toolbar__right">
                                <span className="toolbar-button" onClick={() => this.showSideMenu(true)}>
                                    <i className="ion-navicon" style={{fontSize: '28px'}}/>
                                </span>
                            </div>
                        </div>


                        <div>
                            <div className="list--material list list-schedule-order-selector-wrapper">
                                {this.getOrderSelectorButton()}
                            </div>
                            {
                                this.state.routerParam.type === 'SHARE' || this.state.routerParam.type === 'LOCAL' || this.state.routerParam.type === 'LOCAL_PARENT' ?
                                    <div className="list--material list list-schedule-local-selector-wrapper">
                                        <span>지역: </span>
                                        <select className="select-input select-input--material" value={this.state.localParam.parentCode} onChange={(event) => this.changeLocalParam(event, 'PARENT')}>
                                            <option value={0}>전체</option><option value={11}>서울</option><option value={41}>경기</option><option value={26}>부산</option><option value={27}>대구</option><option value={28}>인천</option><option value={29}>광주</option>
                                            <option value={30}>대전</option><option value={31}>울산</option><option value={36}>세종</option><option value={42}>강원</option><option value={43}>충북</option>
                                            <option value={44}>충남</option><option value={45}>전북</option><option value={46}>전남</option><option value={47}>경북</option><option value={48}>경남</option>
                                            <option value={50}>제주</option>
                                        </select>
                                        {this.getLocalSelector()}
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.routerParam.type === 'INCLUDE' ?
                                    <div className="list--material list">
                                        <div className="list-item__center list-item--material__center">
                                            <div className="list-item__title list-item--material__title" style={{marginLeft: '16px'}}>
                                                {this.state.routerParam.parameter.placeName} <small>이 포함된 일정</small>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.routerParam.type === 'SHARE' ?
                                    <div className="list--material list list-schedule-sort-wrapper">
                                        <span>유형: </span>
                                        <div>
                                            <Row className="list-schedule-sort-row">
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.all} onChange={() => this.useSortOfSchedule('all')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        전체
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row className="list-schedule-sort-row">
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.date} onChange={() => this.useSortOfSchedule('date')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        만남 <i className="fa fa-heart"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.picnic} onChange={() => this.useSortOfSchedule('picnic')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        소풍 <i className="fa fa-child"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.sightseeing} onChange={() => this.useSortOfSchedule('sightseeing')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        관광 <i className="fa fa-eye"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.shopping} onChange={() => this.useSortOfSchedule('shopping')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        쇼핑 <i className="fa fa-shopping-bag"/>
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row className="list-schedule-sort-row">
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.eating} onChange={() => this.useSortOfSchedule('eating')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        먹자 <i className="fa fa-cookie-bite"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.history} onChange={() => this.useSortOfSchedule('history')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        역사 <i className="fa fa-history"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.study} onChange={() => this.useSortOfSchedule('study')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        학습 <i className="fa fa-user-graduate"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.healing} onChange={() => this.useSortOfSchedule('healing')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        힐링 <i className="fa fa-tree"/>
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.activity} onChange={() => this.useSortOfSchedule('activity')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        활동 <i className="fa fa-walking"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.sport} onChange={() => this.useSortOfSchedule('sport')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        운동 <i className="fa fa-swimmer"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.outside} onChange={() => this.useSortOfSchedule('outside')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        실외 <i className="fa fa-door-open"/>
                                                    </label>
                                                </Col>
                                                <Col>
                                                    <label className="radio-button radio-button--material">
                                                        <input type="radio" className="radio-button__input radio-button--material__input" name="sort" checked={this.state.searchSort.inside} onChange={() => this.useSortOfSchedule('inside')}/>
                                                        <div className="radio-button__checkmark radio-button--material__checkmark"></div>
                                                        실내 <i className="fa fa-door-closed"/>
                                                    </label>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.routerParam.type === 'SHARE' ?
                                    <div className="list-schedule-search-wrapper">
                                        <form onSubmit={(e) => this.searchScheduleByTagName(e)}>
                                            <input type="search" placeholder="태그 검색" className="search-input search-input--material" value={this.state.searchScheduleText}
                                                   onChange={(e) => this.fillInForm('searchScheduleText', e)}
                                            />
                                            <button className="button button--material" onClick={(e) => this.searchScheduleByTagName(e)}>검색</button>
                                        </form>
                                    </div>
                                    :
                                    null
                            }
                            <ul className="list--material list list-schedule-list">
                                {
                                    !this.state.scheduleList.isLoading && SL.length === 0 ?
                                        <li className="list-item list-item--material">
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title text-center">
                                                    현재 조건에서 검색된 일정이 없습니다.
                                                </div>
                                            </div>
                                        </li>
                                        :
                                        null
                                }

                                {
                                    SL.map((e, i) => {
                                        return (
                                            <li key={['schedule', 'list', i].join('_')} className="list-item list-item--material">
                                                <div className="list-item__left list-item--material__left" onClick={() => this.showTargetSchedule(e)}>
                                                    <img className="list-item__thumbnail"
                                                         src={NAVER_THUMBNAIL_GETTER(e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]])}
                                                         onError={(e) => {
                                                             e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                         }} alt={e.schedule[e.scheduleOrder[e.thumbnailIndex ? e.thumbnailIndex : 0]].name}/>
                                                </div>
                                                <div className="list-item__center list-item--material__center" onClick={() => this.showTargetSchedule(e)}>
                                                    <div className="list-item__title">{e.title}</div>
                                                    <div className="list-item__subtitle">
                                                        <span onClick={(event) => this.showUserInfoDialog(event, e.uid)}>
                                                            {e.nickname}
                                                        </span>
                                                        {
                                                            this.state.scheduleList.order.type === 'date' ?
                                                                <small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small>
                                                                :
                                                                <small><i className="fa fa-thumbs-up"/> {e.recommend}</small>
                                                        }
                                                        {
                                                            e.sort ?
                                                                <small style={{marginLeft: '4px'}}>
                                                                    {
                                                                        e.sort ?
                                                                            Object.keys(e.sort).map((k, j) => {
                                                                                if(e.sort[k] === true){
                                                                                    return (
                                                                                        <span key={['near', 'schedule', 'sort', i, j].join('_')} className="notification notification--material notification-sort">{SCHEDULE_SORT_KEY_TO_NAME[k]}</span>
                                                                                    )
                                                                                }
                                                                            })
                                                                            :
                                                                            null
                                                                    }
                                                                </small>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="list-item__right list-item--material__right">
                                                    {
                                                        this.state.routerParam.type === 'MINE' ?
                                                            <span className="notification notification--material" onClick={() => this.goToEditSchedule(e)}>수정</span>
                                                            :
                                                            <span className="notification notification--material" onClick={() => this.chooseLocal(e.representative.district.code)}>{e.representative.district.name.substring(0,3)}</span>
                                                    }
                                                    {
                                                        this.state.routerParam.type === 'MINE' ?
                                                            <span className="notification notification--material" onClick={() => this.deleteSchedule(e.DOC_ID)}><i className="fa fa-trash-o"/></span>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </li>
                                        )
                                    })
                                }

                                {
                                    this.state.scheduleList.isLoading ?
                                        <li className="list-item list-item--material">
                                            <div className="list-item__title list-item--material__title text-center">
                                                <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                            </div>
                                        </li>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleList.showMore && !this.state.scheduleList.isLoading ?
                                        <li className="list-item list--inset__item list-item--chevron list-item--chevron-down list-schedule-list" onClick={() => this.getScheduleList(this.props.userInfo, this.state.routerParam, false, null, null)}>
                                            <div className="list-item__center">더보기</div>
                                        </li>
                                        :
                                        null
                                }
                            </ul>
                        </div>

                        <ActionSheet isOpen={this.state.changeListOrderActionSheet.open} animation='default' modifier={'material'}
                                     onCancel={() => this.setState({changeListOrderActionSheet: {...this.state.changeListOrderActionSheet, open: false}})} isCancelable={true} title="정렬 방법">
                            <ActionSheetButton modifier={'material'} onClick={() => this.changeOrderType('date', 'desc')} style={this.state.routerParam.type === 'RECOMMEND' ? {display: 'none'} : {}}>
                                <i className="fa fa-calendar"/> 날짜 ↓
                                {this.state.scheduleList.order.type === 'date' && this.state.scheduleList.order.direction === 'desc' ? <small> (선택됨)</small>: null}
                            </ActionSheetButton>
                            <ActionSheetButton modifier={'material'} onClick={() => this.changeOrderType('date', 'asc')} style={this.state.routerParam.type === 'RECOMMEND' ? {display: 'none'} : {}}>
                                <i className="fa fa-calendar"/> 날짜 ↑
                                {this.state.scheduleList.order.type === 'date' && this.state.scheduleList.order.direction === 'asc' ? <small> (선택됨)</small>: null}
                            </ActionSheetButton>
                            <ActionSheetButton modifier={'material'} onClick={() => this.changeOrderType('recommend', 'desc')}>
                                <i className="fa fa-heart"/> 추천 ↓
                                {this.state.scheduleList.order.type === 'recommend' && this.state.scheduleList.order.direction === 'desc' ? <small> (선택됨)</small>: null}
                            </ActionSheetButton>
                            <ActionSheetButton modifier={'material'} onClick={() => this.changeOrderType('recommend', 'asc')}>
                                <i className="fa fa-heart"/> 추천 ↑
                                {this.state.scheduleList.order.type === 'recommend' && this.state.scheduleList.order.direction === 'asc' ? <small> (선택됨)</small>: null}
                            </ActionSheetButton>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({changeListOrderActionSheet: {...this.state.changeListOrderActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>정렬 방법 닫기</ActionSheetButton>
                        </ActionSheet>

                        <ActionSheet className="target-schedule-action-sheet" isOpen={TSAS.open} animation='default' modifier={'material'}
                                     onCancel={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: false}})} isCancelable={true} title={TSAS.title}>
                            <div className="segment segment--material">
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input" name="target-schedule-segment" checked={TSAS.tab === 'schedule'} onChange={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, tab: 'schedule'}})}/>
                                    <div className="segment__button segment--material__button TUTO_SCHEDULE_TAB_BUTTON">{'지도 + 장소'}</div>
                                </div>
                                <div className="segment__item segment--material__item">
                                    <input type="radio" className="segment__input segment--material__input TUTO_SCHEDULE_DESCRIPTION_TAB_INPUT" name="target-schedule-segment" checked={TSAS.tab === 'description'} onChange={() =>  this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, tab: 'description'}})}/>
                                    <div className="segment__button segment--material__button TUTO_SCHEDULE_DESCRIPTION_TAB_BUTTON">{'설명 + 댓글'}</div>
                                </div>
                            </div>
                            <div className="card card--material" style={{display: TSAS.tab === 'schedule' ? '' : 'none'}}>
                                <NaverMap
                                    id={'naver-map-for-list'}
                                    className={'naver--map TUTO_NAVER_MAP'}
                                    naverRef={ref => { this.naverMapRef = ref }}
                                    style={{width: window.innerWidth, height: GET_HEIGHT_FOR_NAVER_MAP(window.screenSizeProperty === 'md' ? 450 : 250)}}
                                    defaultZoom={8}
                                    minZoom={3}
                                    maxZoom={14}
                                    zoomControl={true}
                                    zoomControlOptions={
                                        {position: this.naverMaps.Position.TOP_RIGHT, style: this.naverMaps.ZoomControlStyle.SMALL, legendDisabled: false}
                                    }
                                    center={TSAS.mapCenter}
                                    onCenterChanged={center => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, mapCenter: center}})}
                                    logoControl={false}
                                    mapDataControl={false}
                                >
                                    <button className="button button--material--flat map-current-button" onClick={this.requestCurrentLocation}>
                                        <i className="ion ion-android-locate"/>
                                    </button>

                                    {
                                        TSAS.open ?
                                            TSAS.data.scheduleOrder.map((key, i) => {
                                                return (
                                                    <Marker key={['scheduled', 'marker', key, i].join('_')}
                                                            position={new this.naverMaps.LatLng(TSAS.data.schedule[key].y, TSAS.data.schedule[key].x)}
                                                            icon= {
                                                                {content: ['<div class="naver-map-pin-mine"',
                                                                        'id="',
                                                                        ['scheduled', 'marker', key, i].join('_'),
                                                                        '">',
                                                                        '<strong>',
                                                                        i + 1,
                                                                        '</strong>',
                                                                        SVG_MARKER_ICON[TSAS.data.schedule[key].type],
                                                                        '</div>'].join('')}
                                                            }
                                                            onClick={(event) => {
                                                                this.showNaverPlaceInFunctions(TSAS.data.schedule[key])
                                                            }}
                                                    />
                                                )
                                            })
                                            :
                                            null
                                    }

                                    {
                                        TSAS.targetToMapCenter ?
                                            <Marker position={new this.naverMaps.LatLng(TSAS.targetToMapCenter.y, TSAS.targetToMapCenter.x)}
                                                    icon= {{content: ['<div class="naver-map-target-to-map-center"', '</div>'].join('')}}
                                            />
                                            :
                                            null
                                    }

                                    {
                                        TSAS.open ?
                                            <Polyline
                                                path={TSAS.polyLine}
                                                strokeColor={'#ffe336'}
                                                strokeStyle={'solid'}
                                                strokeOpacity={0.8}
                                                strokeWeight={3}
                                            />
                                            :
                                            null
                                    }
                                </NaverMap>

                                <ul className="list list--material target-schedule-list TUTO_SCHEDULE_LIST">
                                    {
                                        TSAS.open ?
                                            TSAS.data.scheduleOrder.map((key, i) => {
                                                const e = TSAS.data.schedule[key];
                                                return (
                                                    <li key={['list', key, i].join('_')} className="list-item list-item--material">
                                                        <div className="list-item__left list-item--material__left" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                            <img className="list-item__thumbnail"
                                                                 src={NAVER_THUMBNAIL_GETTER(e)}
                                                                 onError={(e) => {
                                                                     e.target.src = "https://fakeimg.pl/100x100/?text=No Image"
                                                                 }} alt={e.name}/>
                                                        </div>
                                                        <div className="list-item__center list-item--material__center" onClick={() => this.showNaverPlaceInFunctions(e)}>
                                                            <div className="list-item__title list-item--material__title">{i + 1}. {e.name} {e.category ? <small>{e.category}</small>: null}</div>
                                                            <div className="list-item__subtitle list-item--material__subtitle">{e.tags ? e.tags.join(", ") : null}</div>
                                                        </div>
                                                        <div className="list-item__right list-item--material__right" onClick={(event) => this.setTargetToMapCenter(event, e)}>
                                                            <span><i className="fa fa-map-marker-alt"/></span>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                            :
                                            null
                                    }
                                </ul>

                                {
                                    TSAS.open ?
                                        <TargetScheduleActionSheetFunctions TSAS={TSAS} hideTNPAS={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, targetNaverPlaceActionSheet: null}})}/>
                                        :
                                        null
                                }
                            </div>

                            {
                                TSAS.open && TSAS.tab === 'description' ?
                                    <div className="card card--material target-schedule-description-wrapper">
                                        <TargetScheduleActionSheetDescription TSAS={TSAS}/>
                                    </div>
                                    :
                                    <div/>
                            }

                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({targetScheduleActionSheet: {...this.state.targetScheduleActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>일정 닫기</ActionSheetButton>
                        </ActionSheet>

                        {
                            this.state.userInfoDialog.open ?
                                <UserInfoDialog open={true} uid={this.state.userInfoDialog.uid} hide={() => this.setState({userInfoDialog: {...this.state.userInfoDialog, open: false}})}/>
                                :
                                null
                        }
                    </Page>
                </SplitterContent>
            </Splitter>
        )
    }
}

const mapStateToProps = ({user, native}) => ({
    userInfo: user.userInfo,
    usedCurrentLocation: native.usedCurrentLocation,
    currentLocation: native.currentLocation,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
    useCurrentLocation: () => dispatch(useCurrentLocation()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ListSchedule))